export default __webpack_public_path__ + "static/media/sheetMetal.1a4b3bce.svg";